import { Input } from '@tlx/atlas';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useValidatedFormInput, ValidatedFormInputProps } from './hooks/useValidatedFormInput';
import { ErrorMessage } from './ErrorMessage';

export const ValidatedFormInput = forwardRef<HTMLInputElement, ValidatedFormInputProps>(function ValidatedFormInput(
    { className, ...props },
    ref,
) {
    const { errorMessage, showError, inputProps } = useValidatedFormInput({
        ...props,
        ref,
    });
    return (
        <div>
            <Input
                {...inputProps}
                // type="text"
                className={classNames(className, {
                    'atl-border-red-100': showError,
                })}
            />
            <ErrorMessage errorMessage={errorMessage} showError={showError} />
        </div>
    );
});
